import * as React from "react";
const SvgTablecloth = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.883 3a1.75 1.75 0 0 0-1.737 1.533l-.89 7.124a.755.755 0 0 0-.006.11c.007.548.31.95.67 1.195.344.236.766.356 1.164.407.363.046.767.042 1.166-.021v6.902a.75.75 0 0 0 1.5 0v-7.487a2.03 2.03 0 0 1 .964-.263c.357 0 .743.112 1.17.383.62.395 1.282.617 1.973.617.691 0 1.353-.222 1.974-.617.426-.271.813-.383 1.17-.383.356 0 .742.112 1.168.383.621.395 1.283.617 1.974.617.691 0 1.352-.222 1.974-.617.426-.271.812-.383 1.169-.383.298 0 .618.078.964.263v7.487a.75.75 0 0 0 1.5 0v-6.902c.4.063.803.067 1.166.021.398-.05.82-.17 1.164-.407.36-.246.664-.647.67-1.195a.748.748 0 0 0-.006-.11l-.89-7.124A1.75 1.75 0 0 0 21.117 3H2.883Zm19.358 8.72-.876-7.001a.25.25 0 0 0-.248-.219H2.883a.25.25 0 0 0-.248.219l-.875 7a.338.338 0 0 0 .008.006c.081.056.248.123.505.156.526.067 1.125-.046 1.467-.264.622-.395 1.283-.617 1.974-.617.691 0 1.353.222 1.974.617.427.271.813.383 1.17.383.356 0 .742-.112 1.168-.383C10.648 11.222 11.309 11 12 11c.691 0 1.353.222 1.974.617.426.271.812.383 1.169.383.356 0 .743-.112 1.169-.383.621-.395 1.283-.617 1.974-.617.69 0 1.352.222 1.974.617.342.218.941.33 1.467.264.257-.033.424-.1.505-.156l.009-.005Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgTablecloth;
